import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { ILoginPayload, ILoginResponse } from '../../domain/interfaces/login.interface';
import { ILogoutResponse } from '../../domain/interfaces/logout.interface';
import { IVerifyResponseDto } from '../dtos/verify-response.dto';
import { ILogoutResponseDto } from '../dtos/logout-response.dto';
import { AuthMappers } from '../mappers/auth.mappers';
import { environment } from 'src/environments/environment';
import { IRsaCryptoPort, RSA_CRYPTO_PROVIDER } from '@shared/utils/crypto';
import { IAuthRepository } from '../../domain/repositories/auth.repository';
import { handleError } from '@shared/utils/errors';

@Injectable()
export class ApiAuthRepository implements IAuthRepository {
  private readonly loginUrl = environment.loginBackend;
  private readonly logoutUrl = environment.logoutBackend;

  constructor(
    private readonly http: HttpClient,
    @Inject(RSA_CRYPTO_PROVIDER)
    private readonly rsaCrypto: IRsaCryptoPort,
  ) {}

  login(payload: ILoginPayload): Observable<ILoginResponse> {
    const payloadString = JSON.stringify(payload);
    const encryptedDataPromise = this.rsaCrypto.encryptCredentials(
      payloadString,
      environment.encription.publicKey,
    );

    return from(encryptedDataPromise).pipe(
      switchMap((encryptedData) => {
        return this.http.post<IVerifyResponseDto>(this.loginUrl, {
          encryptedData,
        });
      }),
      map(AuthMappers.toVerifySessionResponse),
      catchError((error) => handleError(error, 'Error al verificar la sesión')),
    );
  }

  logout(): Observable<ILogoutResponse> {
    return this.http.post<ILogoutResponseDto>(this.logoutUrl, {}).pipe(
      map(AuthMappers.toLogoutResponse),
      catchError((error) => handleError(error, 'Error al hacer logout')),
    );
  }
}
